export function formatRouteError(error) {
  if (!error) {
    return { message: 'An unexpected error occurred.', details: '' };
  }

  if (typeof error === 'string') {
    return { message: error, details: '' };
  }

  if (error instanceof Error) {
    return {
      message: error.message || 'An unexpected error occurred.',
      details: error.stack || '',
    };
  }

  if (typeof error === 'object' && error !== null) {
    const status = error.status;
    const statusText = error.statusText;
    const dataMessage =
      typeof error.data === 'string'
        ? error.data
        : error.data?.message || error.data?.error;

    if (status != null) {
      return {
        message: dataMessage || `Request failed (${status}${statusText ? ` ${statusText}` : ''})`,
        details:
          typeof error.data === 'object' && error.data !== null
            ? JSON.stringify(error.data, null, 2)
            : '',
      };
    }

    try {
      return {
        message: dataMessage || 'An unexpected error occurred.',
        details: JSON.stringify(error, null, 2),
      };
    } catch {
      return { message: 'An unexpected error occurred.', details: '' };
    }
  }

  return { message: 'An unexpected error occurred.', details: String(error) };
}

export function formatBoundaryError(error, errorInfo) {
  const message =
    error instanceof Error
      ? error.message || 'An unexpected error occurred.'
      : 'An unexpected error occurred.';

  const stack = error instanceof Error ? error.stack || '' : '';
  const componentStack = errorInfo?.componentStack?.trim() || '';
  const details = [stack, componentStack].filter(Boolean).join('\n\n');

  return { message, details };
}
